import htmx from "htmx.org";
// The compatibility extension must load before Alpine initializes.
import "htmx.org/dist/ext/hx-alpine-compat.js";

import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";
import { setCookie } from "./utils/helpers.js";

// Components
import { initCarousel } from "./components/carousels.js";
import {
	initDialogs,
	initDialogHistory,
	initPopupDialogs,
} from "./components/dialogs.js";
import { initBookmarks } from "./components/bookmarks.js";
import { initLibraryFilters } from "./components/library-filters.js";
import { initSelectWidget } from "./components/widgets.js";
// import { initScrollAnimations } from "./components/scroll-animations.js";
// import { initScrollSpy } from "./components/scroll-spy.js";
// import { initSearchForm } from "./components/search.js";

/**
 * Setup global libraries
 */
function setupGlobals() {
	// Make htmx globally available
	window.htmx = htmx;

	// Enable HTMX 4 Alpine compatibility extension globally.
	if (!Array.isArray(window.htmx.config.extensions)) {
		window.htmx.config.extensions = [];
	}

	if (!window.htmx.config.extensions.includes("alpine-compat")) {
		window.htmx.config.extensions.push("alpine-compat");
	}

	// Ensure htmx processes existing DOM regardless of script timing
	// htmx.process(document.body);

	// Make setCookie globally available for Alpine.js
	window.setCookie = setCookie;

	// Register Alpine plugins
	Alpine.plugin(collapse);
	Alpine.plugin(focus);

	// Make Alpine globally available (start after components are registered)
	window.Alpine = Alpine;
}

/**
 * Initialize all components
 */
function init() {
	setupGlobals();

	// Register Alpine component data before starting Alpine
	initCarousel();
	initDialogs();
	initDialogHistory();
	initPopupDialogs();
	initBookmarks();
	initLibraryFilters();
	initSelectWidget();

	// Start Alpine after components are registered
	Alpine.start();

	// Uncomment when needed
	// initScrollSpy();
	// initScrollAnimations();

	// htmx form handling
	// initSearchForm();
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}
